export default "__VITE_ASSET__65272a93__"